import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { subscribeEmails, unSubscribeEmails } from "../service/axiosConfig";

export default function EmailValidationPage() {
  const { action, token } = useParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  // derive once (top of component body, before return)
  const isUnsub = (action || "").toLowerCase() === "unsub";
  const emailStatusMap = {
    sub: 2, // Active
    unsub: 4, // Unsubscribed
    denied: 3, // Denied
  };

  const apiMap = {
    sub: subscribeEmails,
    unsub: unSubscribeEmails,
    denied: unSubscribeEmails, // reuse unsubscribe endpoint
  };
  useEffect(() => {
    if (!token || !action) {
      setStatus("invalid");
      setMessage("Missing validation token or action.");
      return;
    }

    async function run() {
      try {
        const apiCall = apiMap[action];
        const status = emailStatusMap[action];
        const res = await apiCall(token, status);
        setStatus("success");
        setMessage(
          action === "unsub"
            ? "You have successfully unsubscribed from WellCheck updates. You will no longer receive these emails."
            : action === "denied"
            ? "You have denied receiving WellCheck updates. You will not receive any further emails."
            : "Thank you for confirming your subscription. From now on, you’ll receive regular WellCheck emails to help you stay connected with the wellbeing of your loved ones."
        );
      } catch (err) {
        const status = err?.response?.status;
        const msg = err?.response?.data?.message;

        if (status === 410) {
          setStatus("expired");
          setMessage(msg || "This link has expired. Please request a new one.");
        } else if (status === 404) {
          setStatus("notfound");
          setMessage(msg || "Record not found.");
        } else if (status === 400) {
          setStatus("invalid");
          setMessage(msg || "Invalid link.");
        } else {
          setStatus("error");
          setMessage(msg || err.message || "Network or server error.");
        }
      }
    }

    run();
  }, [token, action]);

  return (
    <div>
      {/* Header */}
      <header
        style={{
          backgroundColor: "#561919",
          color: "#fff",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Link
          to="https://myheartline.com/"
          style={{
            fontWeight: "bold",
            fontSize: "1.25rem",
            color: "#fff",
            textDecoration: "underline",
          }}
        >
          Heartline
        </Link>
        {/* <nav style={{ display: "flex", gap: "2rem" }}>
          <Link to="/authentication/sign-up" style={{ color: "#fff", fontWeight: "bold" }}>
            Register
          </Link>
          <Link to="/authentication/demo" style={{ color: "#fff", fontWeight: "bold" }}>
            Demo
          </Link>
        </nav> */}
      </header>
      {/* Content */}
      {/* Content */}
      <main style={{ textAlign: "center", padding: "2rem" }}>
        <div
          style={{
            maxWidth: "500px",
            margin: "2rem auto",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            padding: "1.5rem",
            border: "1px solid #eee",
            fontFamily: "'Segoe UI', sans-serif",
          }}
        >
          {status === "loading" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#561919" }}>Processing your request…</h2>
              <p style={{ color: "#555" }}>This usually takes just a moment.</p>
            </>
          )}

          {status === "success" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#34D399" }}>
                {action === "sub"
                  ? "✅ Email Validated"
                  : action === "unsub"
                  ? "✅ Unsubscribed"
                  : "🚫 Subscription Denied"}
              </h2>
              <p style={{ color: "#555" }}>
                {action === "sub"
                  ? "Thank you for confirming your subscription. From now on, you’ll receive regular WellCheck emails to help you stay connected with the wellbeing of your loved ones."
                  : action === "unsub"
                  ? "You have successfully unsubscribed from WellCheck updates. You will no longer receive these emails."
                  : "You have denied receiving WellCheck updates. You will not receive any further emails."}
              </p>
            </>
          )}

          {status === "expired" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#FCA5A5" }}>⚠ Link Expired</h2>
              <p style={{ color: "#555" }}>{message}</p>
            </>
          )}

          {status === "notfound" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#FCA5A5" }}>❌ Record Not Found</h2>
              <p style={{ color: "#555" }}>{message}</p>
            </>
          )}

          {status === "invalid" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#FCA5A5" }}>❌ Invalid Link</h2>
              <p style={{ color: "#555" }}>{message}</p>
            </>
          )}

          {status === "error" && (
            <>
              <h2 style={{ marginBottom: "0.5rem", color: "#FCA5A5" }}>🚫 Something Went Wrong</h2>
              <p style={{ color: "#555" }}>{message}</p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
